import { render, staticRenderFns } from "./changePage.vue?vue&type=template&id=153e49e1&scoped=true&"
import script from "./changePage.vue?vue&type=script&lang=js&"
export * from "./changePage.vue?vue&type=script&lang=js&"
import style0 from "./changePage.vue?vue&type=style&index=0&id=153e49e1&scoped=true&lang=less&"
import style1 from "./changePage.vue?vue&type=style&index=1&id=153e49e1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e49e1",
  null
  
)

export default component.exports